
import { Options, Vue }    from 'vue-class-component';
import SalonCard from '../components/shared/salon-card.vue';
import { ref } from 'vue';

@Options({
  components: {
    SalonCard
  },
  data(){
    return {
      salonList: this.$store.state.salonList,
      filteredSalons: [],
      searchValue: null,
      current: ref(1),
      indexMax: null,
      defaultPageSize: 20
    }
  },
  mounted() {
    this.filteredSalons = this.salonList;
    this.indexMax = this.current * this.defaultPageSize;
  },
  watch: {
    current(i){
      this.indexMax = i * this.defaultPageSize;
    },
    searchValue(v){
      this.filterSalons();
    }
  },
  methods: {
    filterSalons(){
      const selectedSalon = this.$store.state.salon;
      this.filteredSalons = this.salonList.filter(x => x.postnaStevilka?.includes(this.searchValue) || x.mesto?.toLowerCase().includes(this.searchValue.toLowerCase()));
      this.current = 1;
      if(this.filteredSalons.indexOf(selectedSalon) === -1){
        this.$store.commit('setSalon',null);
      }
    },
    async filterByPost(){
      const selectedSalon = this.$store.state.salon;
      this.filteredSalons = await this.filteredSalons.sort((x,y) => parseInt(x.postnaStevilka) - parseInt(y.postnaStevilka));
      this.current = 1;
      if(this.filteredSalons.indexOf(selectedSalon) === -1){
        this.$store.commit('setSalon',null);
      }
    },
    async filterByCity(){
      const selectedSalon = this.$store.state.salon;
      this.filteredSalons = await this.filteredSalons.sort((x, y) => {
        return ('' + x.mesto).localeCompare(y.mesto);
      });
      this.current = 1;
      if(this.filteredSalons.indexOf(selectedSalon) === -1){
        this.$store.commit('setSalon',null);
      }
    },
    async filterByTitle(){
      const selectedSalon = this.$store.state.salon;
      this.filteredSalons = await this.filteredSalons.sort((x, y) => {
        return ('' + x.title).localeCompare(y.title);
      });
      this.current = 1;
      if(this.filteredSalons.indexOf(selectedSalon) === -1){
        this.$store.commit('setSalon',null);
      }
    },
    salonSelected(salon){
      this.$store.commit('setSalon',salon);
    }
  }
})
export default class SalesSalon extends Vue {}
